import * as React from 'react'

/**
 * @description Telegram icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Telegram } from '@sravni/design-system-icons'
 *
 * <Telegram />
 * ```
 */
export const Telegram = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Telegram" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.622 8.8s-.672.234-.619.664c.053.43.602.627.602.627l3.574 1.219 8.583-5.52s.495-.305.477 0c0 0 .089.054-.177.305-.265.25-6.742 6.147-6.742 6.147l-.013.11 5.835 4.531c.974.43 1.328-.466 1.328-.466L18 3.497c0-.861-1.168-.341-1.168-.341L2.622 8.8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.514 13.826 8.232 16.22s-.18.14-.378.052l.378-4.021 3.282 1.575Z"
      fill="currentColor"
    />
  </svg>
))
